export default "__VITE_ASSET__D0f$Io7k__"